import React from 'react';

const SkeletonCard = () => (
  <div className="rounded-3xl overflow-hidden bg-surface-50 border border-surface-100">
    <div className="aspect-[4/3] bg-gradient-to-br from-surface-100 to-surface-200 animate-pulse" />
    <div className="p-6 space-y-3">
      <div className="h-5 bg-surface-100 rounded-full w-3/4 animate-pulse" />
      <div className="h-3 bg-surface-100 rounded-full w-full animate-pulse" />
      <div className="h-3 bg-surface-100 rounded-full w-2/3 animate-pulse" />
      <div className="h-9 bg-surface-100 rounded-xl w-28 mt-4 animate-pulse" />
    </div>
  </div>
);

const LoadingPlaceholder = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      <SkeletonCard />
      <SkeletonCard />
      <SkeletonCard />
    </div>
  );
};

export default LoadingPlaceholder;
